import { AxiosResponse, AxiosRequestConfig } from 'axios';

import * as LLog from '@utils/llogWrapper'; // eslint-disable-line import/no-cycle
import PhfExposure from '@utils/phf/PhfExposure';

const logAxiosAjaxResponse = (response: AxiosResponse) => {
    // 记录请求日志
    try {
        const responseData = response.data;
        LLog.info(
            {
                url: response.config.url,
                hCode: response.status, // http 状态码
                bCode: typeof responseData === 'string' ? '' : responseData.code, // 业务状态码
                bMsg: typeof responseData === 'string' ? '' : responseData.msg, // 业务消息
                tId:
                    response.headers &&
                    (response.headers['M-TraceId'] || response.headers['m-traceid']), // M-TraceId
                rParams: response.config.params, // 对应请求的 params
                t:
                    response.config.meta && response.config.meta.requestStartedAt
                        ? new Date().getTime() - response.config.meta.requestStartedAt
                        : '', // 请求耗时ms
            },
            LLog.REPORT_TAG_TYPE.REQUEST,
        );
    } catch (e) {
        LLog.warn(
            { message: `记录网络请求失败 => ${response.config.url}` },
            LLog.REPORT_TAG_TYPE.REQUEST,
        );
    }
};

/**
 * 对 Ajax 请求拦截，进行Logan日志上报
 * @param response 请求返回的response
 */
const onFulfilled = (response: AxiosResponse) => {
    // 记录请求日志
    logAxiosAjaxResponse(response);
    return response;
};

interface ErrorFromAxios extends Error {
    response?: AxiosResponse;
}

const onRejected = (error: ErrorFromAxios) => {
    // 确定是从 axios 中抛出来的 Error
    if (error.response) {
        logAxiosAjaxResponse(error.response);

        const response: AxiosResponse = error.response;
        const currentUrlPath = (response.config.url || '').split('?')[0];
        /* jscpd:ignore-start */
        if (/^\/gw\/phf\//.test(currentUrlPath)) {
            try {
                let duration = 0;
                const config: AxiosRequestConfig & { meta?: { requestStartedAt?: number } } =
                    response.config;
                if (config && config.meta && config.meta.requestStartedAt) {
                    duration = Date.now() - config.meta.requestStartedAt;
                }

                const Exposure = PhfExposure.getInstance();
                Exposure.reportApi({
                    name: response.request?.responseURL,
                    networkCode: response.status,
                    statusCode: response.data?.code,
                    responseTime: duration,
                });
            } catch (e) {
                console.log('拼好饭业务状态码上报异常');
            }
        }
        /* jscpd:ignore-end */
    }
    return Promise.reject(error);
};

export default {
    onFulfilled,
    onRejected,
};
